import { createContext } from 'react';

import { FormControlContextType } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FormControlContext = createContext<FormControlContextType<any>>(({
  setValue: () => {},
} as unknown) as FormControlContextType);

export default FormControlContext;
